module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "home-hero"
  }, [_c('div', {
    staticClass: "home-hero__overlay"
  }, [_c('video', {
    directives: [{
      name: "load-directive",
      rawName: "v-load-directive"
    }],
    staticClass: "home-hero__video",
    attrs: {
      "loop": "loop",
      "muted": "muted",
      "autoplay": "autoplay"
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    staticClass: "home-hero__source",
    attrs: {
      "src": _vm.props.acf.hero_video,
      "type": "video/mp4",
      "poster": _vm.props.acf.poster
    }
  }), _vm._v("Your browser does not support video.")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77d91eaf","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/home-hero/home-hero.pug
// module id = 725
// module chunks = 1